import React from "react";
import { Menu, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { UserType } from "../../api/Authentication";

/**
 * SystemTabs: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Component which displays the always-visible system tabs
 * in the top bar, such as Home, Agenda and Settings.
 *
 * @param {*} props
 */
const SystemTabs = props => (
  <div className="ax-system-tabs">
    <Menu>
      {/**
       * Conditionally renders the Agenda tab for students
       */}
      {props.userType !== UserType.Teacher ? (
        <Link to="/agenda">
          <Menu.Item
            content={<Icon name="home" />}
            active={props.currentApplication === "/agenda"}
          />
        </Link>
      ) : null}
      {/**
       * Displays the system tab for the Organizer
       */}
      <Link to="/organizer">
        <Menu.Item
          content={<Icon name="folder" />}
          active={props.currentApplication === "/organizer"}
        />
      </Link>
      {/**
       * Displays the system tab for Settings
       */}
      <Link to="/settings">
        <Menu.Item
          content={<Icon name="setting" />}
          active={props.currentApplication === "/settings"}
        />
      </Link>
    </Menu>
  </div>
);

SystemTabs.propTypes = {
  /**
   * currentApplication: String
   * Currently open application URL (e.g. "/dashboard")
   */
  currentApplication: PropTypes.string.isRequired,

  /**
   * Type of currenlty logged in user
   */
  userType: PropTypes.string.isRequired
};

export default SystemTabs;



// WEBPACK FOOTER //
// ./src/components/contextbar/SystemTabs.js